const vip = [{
  path: '/open-vip',
  name: 'open-vip',
  component: () => import( /* webpackChunkName: "openvip" */ '@/pages/vip/open-vip.vue'),
  meta: {
    login: true,
    titleBar: {
      title: '开通VIP',
      hasMenu: true
    }
  }
}, {
  path: '/vip-qy',
  name: 'vip-qy',
  component: () => import( /* webpackChunkName: "vipqy" */ '@/pages/vip/vip-qy.vue'),
  meta: {
    login: true,
    titleBar: {
      title: '会员中心',
      hasMenu: true
    }
  }
}, {
  path: '/renew-agreement',
  name: 'renew-agreement',
  component: () => import( /* webpackChunkName: "renewagreement" */ '@/pages/vip/renew-agreement.vue'),
  meta: {
    login: true,
    titleBar: {
      title: '协议',
      hasMenu: true
    }
  }
}, {
  path: '/vip-agreement',
  name: 'vip-agreement',
  component: () => import( /* webpackChunkName: "vipagreement" */ '@/pages/vip/vip-agreement.vue'),
  meta: {
    login: true,
    titleBar: {
      title: '协议',
      hasMenu: true
    }
  }
}]

export default vip
